import Modal from '@/components/ui/Modal';
import { Icon } from '@iconify/react';
import Button from '@/components/ui/Button';

interface NotificationProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message: string;
  variant?: 'success' | 'error';
  textAlign?: 'left' | 'center' | 'right';
}

const Notification: React.FC<NotificationProps> = ({
  isOpen,
  onClose,
  title,
  message,
  variant = 'success',
  textAlign = 'center',
}) => {
  const icon = variant === 'success' ? 'mdi:check-circle-outline' : 'mdi:alert-circle-outline';
  const color = variant === 'success' ? 'text-green-500' : 'text-red-500';
  const alignClass =
    textAlign === 'left' ? 'text-left' : textAlign === 'right' ? 'text-right' : 'text-center';

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm">
      <div className="flex flex-col items-center gap-4 py-4">
        <Icon icon={icon} className={`w-12 h-12 ${color}`} />
        <div
          className={`text-sm text-gray-700 ${alignClass} whitespace-pre-wrap max-h-72 overflow-auto`}
        >
          {message}
        </div>
        <div className="w-full flex justify-center pt-2">
          <Button type="button" variant="primary" onClick={onClose}>
            OK
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default Notification;
